import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Polygon from 'react-google-maps/lib/components/Polygon';

const opacity1 = 0.08,
  opacity2 = 0.18,
  opacity3 = 0.3,
  opacity4 = 0.42;

const getPolygonOpacity = (selectedPolygonId, thisId) => {
  return selectedPolygonId !== undefined
    ? selectedPolygonId === thisId
      ? opacity4
      : opacity1
    : opacity3;
};

class MapPolygons extends PureComponent {
  static defaultProps = {
    item: [],
    selectedPolygonId: undefined,
    name: '',
    deliveryGroups: [],
  };

  static propTypes = {
    item: PropTypes.object.isRequired,
    polygonClick: PropTypes.func.isRequired,
    restaurantId: PropTypes.number,
    selectedPolygonId: PropTypes.any,
    isMarkerHover: PropTypes.bool,
    hintLayout: PropTypes.func,
    currency: PropTypes.string,
    name: PropTypes.string,
    deliveryGroups: PropTypes.array,
  };

  state = {
    isHover: false,
    polygonOpacity: getPolygonOpacity(this.props.selectedPolygonId, this.props.item.polygon_id),
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedPolygonId !== this.props.selectedPolygonId) {
      this.setState({
        polygonOpacity: getPolygonOpacity(nextProps.selectedPolygonId, this.props.item.polygon_id),
      });
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  geometry = (this.props.item.polygon || []).map(pol => ({
    lng: parseFloat(pol[0]),
    lat: parseFloat(pol[1]),
  }));

  onClick = () => {
    this.props.polygonClick(this.props.restaurantId, this.props.item.polygon_id);
  };

  polygonMouseHover = enter => {
    const { selectedPolygonId, item } = this.props;

    if (enter && !this.state.isHover && selectedPolygonId !== item.polygon_id) {
      this.setState({
        polygonOpacity:
          selectedPolygonId !== undefined
            ? selectedPolygonId === item.polygon_id
              ? opacity4
              : opacity2
            : opacity4,
      });

      this.setState({ isHover: true });
    } else if (!enter && this.state.isHover && !this.props.isMarkerHover) {
      this.setState({
        polygonOpacity:
          selectedPolygonId !== undefined
            ? selectedPolygonId === item.polygon_id
              ? opacity4
              : opacity1
            : opacity3,
      });

      this.setState({ isHover: false });
    }
  };

  onMouseLeave = () => {
    this.timer = setTimeout(() => this.polygonMouseHover(false), 50);
  };

  onMouseEnter = () => {
    clearTimeout(this.timer);
    this.polygonMouseHover(true);
  };

  render() {
    const {
      item,
      hintLayout,
      selectedPolygonId,
      currency,
      name,
      deliveryGroups,
      isOpeningSoon,
    } = this.props;
    const { polygonOpacity } = this.state;
    let isMaxPrice;

    if (deliveryGroups.length > 1) {
      if (item.min_sum === deliveryGroups[1].min_sum) {
        isMaxPrice = true;
      }
    } else {
      isMaxPrice = false;
    }

    const openingSoonColors = {
      fill: 'rgb(128, 128, 128)',
      stroke: 'rgb(163, 157, 155)',
      strokeLight: 'rgb(108, 173, 158)',
    };

    const standardColors = {
      fill: 'rgb(0, 148, 113)',
      fillMaxPrice: 'rgb(194, 19, 19)',
      stroke: 'rgb(0, 148, 113)', //'#009471'
      strokeLight: 'rgb(108, 173, 158)', //'#6cad9e',
    };
    const deliveryGroup = deliveryGroups.find(group => group.min_sum === item.min_sum) || {};
    const color = deliveryGroup.color || 'rgb(250, 240, 225)';
    const zIndex = deliveryGroup.zIndex || 5;

    const standardPolygonOptions = {
      fillColor: color,
      strokeColor: color,
      zIndex,
      fillOpacity: polygonOpacity,
      strokeWeight: 2,
    };

    const openSoonPolygonOptions = {
      fillColor: openingSoonColors.fill,
      strokeColor:
        selectedPolygonId !== undefined
          ? selectedPolygonId === item.polygon_id
            ? openingSoonColors.stroke
            : openingSoonColors.strokeLight
          : openingSoonColors.stroke,
      fillOpacity: polygonOpacity,
      strokeWeight: 2,
    };

    return (
      <Polygon
        paths={this.geometry}
        onClick={this.onClick}
        onMouseOver={this.onMouseEnter}
        onMouseOut={this.onMouseLeave}
        options={isOpeningSoon ? { ...openSoonPolygonOptions } : { ...standardPolygonOptions }}
        properties={{
          object: 'с 11:00 до 23:00',
          sum: item.min_sum,
          name: name,
          currency: currency,
        }}
      />
    );
  }
}

export default MapPolygons;
